import { render, staticRenderFns } from "./FormulaModel.vue?vue&type=template&id=4431a2fa&scoped=true"
import script from "./FormulaModel.vue?vue&type=script&lang=js"
export * from "./FormulaModel.vue?vue&type=script&lang=js"
import style0 from "./FormulaModel.vue?vue&type=style&index=0&id=4431a2fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4431a2fa",
  null
  
)

export default component.exports